export default __webpack_public_path__ + "static/media/evitar-peretz.a5b03eff.png";